module.exports = __webpack_public_path__ + "img/cover24.d18b77ca.png";